import { FC } from 'react';
import { Button, ButtonSizes, Icon } from '@silverfort/sf-components';
import useHideTowerLayout from '../../../TowerLayout/hooks/hideTowerLayout';

interface MessagePageProps {
    icon?: React.FC<React.SVGProps<SVGSVGElement>>;
    title?: string;
    bigMsg?: string;
    smallMsgs?: string[];
    buttonText?: string;
    onButtonClick?: () => void;
    darkMode?: boolean;
    hasWrapper?: boolean;
}

const DARK_CLASSES = {
    container: "px-5 bg-black h-full items-center flex justify-center text-center min-h-[125px] flex-col",
    iconContainer: "flex w-14 h-14 justify-center items-center gap-2 rounded-lg border border-[#333] bg-[#1A1919] mb-4",
    title: "text-white font-light text-[104px] font-['Bitter'] h-[125px] m-0 mb-4",
    errorMessage: "text-white font-sf-poppins mb-10",
    bigMessage: "text-[21px] h-6 mb-2 font-medium",
    smallMessage: "text-white text-base h-6 font-normal"
};

const LIGHT_CLASSES = {
    container: "px-5 bg-white h-full items-center flex justify-center text-center min-h-[125px] flex-col",
    iconContainer: "flex w-14 h-14 justify-center items-center gap-2 rounded-lg border border-gray-300 bg-gray-0 mb-4",
    title: "text-black font-light text-[104px] font-['Bitter'] h-[125px] m-0 mb-4",
    errorMessage: "text-black font-sf-poppins mb-10",
    bigMessage: "text-[21px] h-6 mb-2 font-medium",
    smallMessage: "text-black text-base h-6 font-normal"
};

const MessagePage: FC<MessagePageProps> = ({
    icon = undefined,
    title = '',
    bigMsg = '',
    smallMsgs = [],
    buttonText = '',
    onButtonClick = () => {},
    darkMode = true,
    hasWrapper=false
}) => {
  useHideTowerLayout();
  
  const classes = darkMode ? DARK_CLASSES : LIGHT_CLASSES;
  
  const smallMsgElements = smallMsgs.map((msg, index) => (
    <div className={classes.smallMessage} key={index}>
      {msg}
    </div>
  ));
  
  return (
    <div className={`${classes.container} ${hasWrapper ? 'pb-13' : ''}`}>
      {icon && (
        <div className={classes.iconContainer}>
          <Icon icon={icon} size={32} />
        </div>
      )}
      {title && (
        <h1 className={classes.title}>
          {title}
        </h1>
      )}
      <span className={classes.errorMessage}>
        {bigMsg && (
          <div className={classes.bigMessage}>
            {bigMsg}
          </div>
        )}
        {smallMsgElements}
      </span>
      {buttonText && (
        <Button buttonSize={ButtonSizes.Large} text={buttonText} onClick={onButtonClick} />
      )}
    </div>
  );
};

export default MessagePage; 